export const EVALUATION_STATUS = {
  PENDING: 4,
  ASSIGNED: 20,
  SKIPPED: 30,
  SCORES_GIVEN: 40,
  COMPLETED: 50,
  DELETED: 100
};

export const QUESTION_TYPE_MAP = {
  SINGLE: 1,
  MCQ: 2,
  INTEGER: 3
};

export const QUESTION_TYPES = [
  { label: 'Single choice correct', value: QUESTION_TYPE_MAP.SINGLE },
  { label: 'Multiple choice correct', value: QUESTION_TYPE_MAP.MCQ },
  { label: 'Integer', value: QUESTION_TYPE_MAP.INTEGER }
];

export const INTEGER_TYPE_MAP = {
  INTEGER: 0,
  ALPHA: 1
};

export const INTEGER_TYPES = [
  { label: 'Integer', value: 0 },
  { label: 'Alphanumeric', value: 1 }
];

export const ANSWER_STATUS = {
  CORRECT_ATTEMPT: 1,
  INCORRECT_ATTEMPT: 2,
  SKIPPED: 3
};

export const NO_PREFRENCE = { display_name: 'No preference', code: -1 };
